export const validateProfileData = (profileData) => {
  const errors = {};

  // Validate Full Name
  if (!profileData.name || profileData.name.trim() === "") {
    errors.name = "Full name is required.";
  } else if (!/^[a-zA-Z\s'-]+$/.test(profileData.name)) {
    errors.name =
      "Full name can only contain letters, spaces, hyphens, or apostrophes.";
  } else if (profileData.name.length < 2 || profileData.name.length > 50) {
    errors.name = "Full name must be between 2 and 50 characters.";
  }

  // Validate Email
  if (!profileData.email || profileData.email.trim() === "") {
    errors.email = "Email is required.";
  } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(profileData.email)) {
    errors.email = "Invalid email address.";
  } else if (profileData.email.length > 100) {
    errors.email = "Email must not exceed 100 characters.";
  }

  // // Validate Phone (Phone Code + Phone Number)
  // if (!profileData.phoneCode || !profileData.phoneNumber) {
  //   errors.phone = "Phone code and number are required.";
  // } else {
  //   // Validate Phone Number Length and Format
  //   const phoneRegex = /^[0-9]{7,15}$/; // Phone number must be numeric and 7-15 digits long
  //   if (!phoneRegex.test(profileData.phoneNumber)) {
  //     errors.phone =
  //       "Phone number must be between 7 and 15 digits and contain only numbers.";
  //   }
  // }

  // Validate Country of Residence
  if (!profileData.country || profileData.country.trim() === "") {
    errors.country = "Country of residence is required.";
  }

  // // Validate Employee Number
  // if (!profileData.employeeNumber || profileData.employeeNumber.trim() === "") {
  //   errors.employeeNumber = "Employee number is required.";
  // } else if (!/^\d+$/.test(profileData.employeeNumber)) {
  //   errors.employeeNumber = "Employee number must contain only digits.";
  // } else if (
  //   profileData.employeeNumber.length < 1 ||
  //   profileData.employeeNumber.length > 10
  // ) {
  //   errors.employeeNumber =
  //     "Employee number must be between 1 and 10 characters.";
  // }

  // Validate Role
  if (!profileData.role || profileData.role.trim() === "") {
    errors.role = "Department-Role is required.";
  }

  return errors;
};
